import React from "react";
import './Hero.css'
import Tilt from 'react-tilt';
import Zoom from 'react-reveal/Zoom';
import { useNavigate } from "react-router-dom";
import {Link} from "react-router-dom";
import AboutMe from '../About/AboutMe'
import 'flowbite'


const Hero = () => {
    return (
  <>
 <Zoom>
  <section className="heroo">
  <div className="flex flex-wrap overflow-hidden md:-mx-32 xl:-mx-4  py-20 mt-10">

<div className="w-full overflow-hidden md:my-32 md:px-32 xl:my-2 xl:px-2 text-center py-20">
 <Tilt> <h1 className="head">Hi, my name is <span id="head1">Piyush Yadav</span></h1>
 </Tilt>
</div>

<div className="w-full text-center overflow-hidden md:my-32 md:px-32 xl:my-2 xl:px-2 ">
<div className="divu text-3xl text-rose-600">WEB DEVELOPER</div> 
<div className="divu"> 
  <span className="text-3xl text-rose-600">PROGRAMMER </span>
</div>
</div>

</div>
<br />
<br />

<div className=" mr-32">
  {/* <Link to="/contact"  className="know primary-button"> GET IN TOUCH
  </Link> */}
  <Link to="/contact" className="holu">Connect+</Link>
  </div>
  <br />
  <br />
  <br />
</section>
<br />
<br />
</Zoom>
  </>
    
    )
}


export default Hero